/**
 * Removes locale, hash, query, and trailing slash from the provided path.
 *
 * @param {Options} [options={}] - Configuration options.
 * @param {boolean} [options.keepHash=false] - If `true`, keeps the hash in the cleaned path.
 * @param {boolean} [options.keepQuery=false] - If `true`, keeps the query string in the cleaned path.
 */
export default function cleanPagePath(
  originalPath: string,
  options?: CleanPagePathOptions,
): string {
  const { keepHash = false, keepQuery = false } = options || {};

  let res = originalPath;

  if (!keepQuery && originalPath.includes('?')) {
    res = originalPath.slice(0, originalPath.indexOf('?'));

    if (keepHash && originalPath.includes('#')) {
      res += originalPath.slice(originalPath.indexOf('#'));
    }
  } else if (!keepHash && originalPath.includes('#')) {
    res = originalPath.slice(0, originalPath.indexOf('#'));
  }

  return `/${res.split('/').slice(2).filter(Boolean).join('/')}`;
}

export interface CleanPagePathOptions {
  keepHash?: boolean;
  keepQuery?: boolean;
}
